import { render, staticRenderFns } from "./right-table.vue?vue&type=template&id=073b189b&scoped=true"
import script from "./right-table.vue?vue&type=script&lang=js"
export * from "./right-table.vue?vue&type=script&lang=js"
import style0 from "./right-table.vue?vue&type=style&index=0&id=073b189b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073b189b",
  null
  
)

export default component.exports